import React from "react";
import SmallSlidePanel from "../add_customer/SmallSlidePanel";

const SaveChanges = ({
  id,
  isSaveChanges,
  closeSaveChanges,
  handleSaveChangesButton,
}) => {
  const handleCancelButtonCLick = () => {
    closeSaveChanges();
  };

  return (
    <SmallSlidePanel
      isOpen={isSaveChanges}
      onClose={closeSaveChanges}
      width={500} // roughly equivalent to max-w-lg
      showCloseButton={true}
    >
      <div className="p-5">
        <div className="mb-4">
          <div className="text-[#000] text-[20px] font-normal mt-5">
            <p>Are you sure you want to save these changes?</p>
          </div>

          <div className="text-[#000] text-[15px] font-[300] mt-5">
            <p>
              Changing metadata may affect the validity of this document. Ensure
              that the new details match the user's official records.
            </p>
          </div>

          <div className="flex items-center mt-5">
            <div className="mr-5">
              <button
                onClick={handleCancelButtonCLick}
                data-modal-toggle={id}
                type="button"
                className="text-[#FFF] bg-[#FF3232] hover:bg-[#FF3232] focus:outline-none font-[500] rounded-[5px] text-md text-medium px-5 py-2 text-center"
              >
                No, cancel
              </button>
            </div>

            <button
              onClick={handleSaveChangesButton}
              data-modal-toggle={id}
              type="button"
              className="text-[#074073] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-md px-5 py-2 text-center bg-[#7FB8EB]"
            >
              Yes, save
            </button>
          </div>
        </div>
      </div>
    </SmallSlidePanel>
  );
};

export default SaveChanges;
